import { ethers } from 'ethers';
import { createContext } from 'react';
import { primaryRpcUrl } from '../utils/rpcEnv';

const arcTestnetTokenList = require('./arcTestnetTokenList.json');
const arcMainnetTokenList = require('./arcMainnetTokenList.json');

export const targetChainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10);

/** Explicit testnet mode, or Arc testnet chain id 5042002. */
export const isTestnetMode =
    ['true', '1', 'yes'].includes(
        String(process.env.REACT_APP_TESTNET_MODE || '').toLowerCase(),
    ) || targetChainId === 5042002;

export const isMainnetMode =
    !isTestnetMode &&
    (targetChainId === 5042 ||
        ['true', '1', 'yes'].includes(
            String(process.env.REACT_APP_MAINNET_MODE || '').toLowerCase(),
        ));

/** Circle faucet — testnet only. */
export const testnetFaucetUrl =
    process.env.REACT_APP_TESTNET_FAUCET_URL || 'https://faucet.circle.com/';

let defaultTokenList = [];
let whiteList = [];

if (targetChainId === 5042) {
    defaultTokenList = arcMainnetTokenList;
    whiteList = arcMainnetTokenList;
} else if (targetChainId === 5042002) {
    defaultTokenList = arcTestnetTokenList;
    whiteList = arcTestnetTokenList;
}

export const initialTokenList = defaultTokenList;
export const tokenWhiteList = whiteList;

export const supportedChainId = [process.env.REACT_APP_CHAIN_ID];
export const hexChainId = process.env.REACT_APP_CHAIN_ID_HEX;
export const chainName = process.env.REACT_APP_CHAIN_NAME;
export const nativeToken = process.env.REACT_APP_NATIVE_TOKEN_SYMBOL;
export const tokenDecimal = process.env.REACT_APP_NATIVE_TOKEN_DECIMAL;

const requireAddress = (value, label) => {
    const address = String(value || '').trim();
    if (!address || !ethers.isAddress(address)) {
        if (typeof console !== 'undefined') {
            console.error(
                `[CronPay] Missing/invalid ${label}. Set it in .env before mainnet use.`,
            );
        }
        return '';
    }
    return address;
};

export const CPGAddress = requireAddress(
    process.env.REACT_APP_CPG_ADDRESS,
    'REACT_APP_CPG_ADDRESS',
);

/** Jobs Diamond — must be set explicitly (no silent testnet fallback). */
export const TASK_ESCROW_ADDRESS = requireAddress(
    process.env.REACT_APP_TASK_ESCROW_ADDRESS,
    'REACT_APP_TASK_ESCROW_ADDRESS',
);

/** Whitelisted ERC20 for job escrows (Arc USDC predeploy). */
export const JOB_ESCROW_PAYMENT_TOKEN = requireAddress(
    process.env.REACT_APP_JOB_PAYMENT_TOKEN ||
        '0x3600000000000000000000000000000000000000',
    'REACT_APP_JOB_PAYMENT_TOKEN',
);

// IPFS/Pinata not used in mainnet Jobs flows — kept only if some legacy import remains.
export const PINATA_JWT = process.env.REACT_APP_PINATA_JWT;
export const IPFS_GATEWAY = process.env.REACT_APP_IPFS_GATEWAY;

/** Primary JSON-RPC URL (same first entry as wagmi / publicClient). */
export const rpcUrl = primaryRpcUrl ?? '';
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const UINT256_MAX = ethers.MaxUint256;
export const pageSizeLength = [10, 25, 50, 100];
export const defaultPageSize = 10;
/** Default decimal places for token/payment amounts shown in the UI. */
export const AMOUNT_DISPLAY_DECIMALS = 4;
/** Amounts below this render as "< 0.0001" (see formatThresholdLabel). */
export const AMOUNT_DISPLAY_MIN_THRESHOLD = 0.0001;
export const disputeDuration = 604800;
export const DIRECT_PAYMENT = 'Direct Payment';
export const TRACKED_PAYMENT = 'Tracked Payment';
export const TASK_PAYMENT = 'Task Payment';
export const SEND = 'Send';
export const RECEIVE = 'Receive';
export const PENDING_DISPUTE = 'pendingDispute';
export const RESOLVE_DISPUTE = 'resolveDispute';

export const ConnectWalletContext = createContext();
export const WalletAddressContext = createContext();
export const TokenContext = createContext();
